import React from "react"
import PageTransition from 'gatsby-plugin-page-transitions'
import get from 'lodash/get'

import Header from '../components/Header/index'
import {Helmet} from 'react-helmet'

import BlogMenu from '../components/BlogMenu'
import BlogPostExcerpt from '../components/BlogPostExcerpt'
import { Cell, ResponsiveContainer } from '../components/ResponsiveGrid'
import ReadMoreButton from '../components/ReadMoreButton'

import map from 'lodash/map'
import filter from 'lodash/filter'
import startCase from 'lodash/startCase'
import includes from 'lodash/includes'

const toList = ['web', 'arduino', 'iot', 'laravel', 'hydroponie', 'quick-tips', 'javascript']

export default ({ data }) => (<PageTransition>
  <div className="Atrakeur-Page">
    <Helmet>
      <meta charSet="utf-8" />
      <title>Atrakeur: DIY, Modelisme et Web</title>
    </Helmet>

    <Header
      contentText={`<h1>${get(data, 'contentfulCategory.title')}</h1>`}
      contentImage={get(data, 'contentfulCategory.featuredImage.resolutions')}
      size="medium" />

    <div className="Atrakeur-Content">
      <BlogMenu />

      { map(
        filter(data.allContentfulBlogPost.edges, node => node.node.category.id === data.contentfulCategory.id),
        ({node: post}, index) => (
          <BlogPostExcerpt post={post} inverted={index % 2 == 1} key={post.id} />
        )
      )}
      
      <ResponsiveContainer className="Atrakeur-BlogPost-Tags">
        <Cell colSpanDesktop="6" colSpanTablet="4" colSpanMobile="4" withPadding withMarginHor white>
          Sujets principaux: { map(get(data, 'allContentfulTag.edges'), tag => (includes(toList, tag.node.slug) && <ReadMoreButton to={`/blog/tag-${tag.node.slug}`}>
           { startCase(tag.node.name) }
          </ReadMoreButton>))}
        </Cell>
      </ResponsiveContainer>

    </div>
  </div> 
</PageTransition>)

export const query = graphql`
query CategoryQuery($id: String!) {
	contentfulCategory(id: { eq: $id }) {
		id
    title
    slug
    featuredImage {
			resolutions(width: 2048) {
        ...GatsbyContentfulResolutions
      }
    }
	}
    
  allContentfulTag {
    edges {
      node {
        id
        slug
        name
      }
    }
  }

  allContentfulBlogPost(sort: { fields: [createdAt], order: DESC}) {
    edges {
      node {
        id
        title
        slug
        category {
          id
          slug
        }
        featured {
          id
          resolutions(width: 2048) {
            ...GatsbyContentfulResolutions
          }
        }
        childContentfulBlogPostContentTextNode {
          childMarkdownRemark {
            excerpt(pruneLength: 300)
          }
        }
      }
    }
	}
}
`



// WEBPACK FOOTER //
// ./src/templates/Category.js